
import { Vue, Options } from "vue-class-component";

@Options({
    props: {
        article: Object,
    },
})
export default class CardComponent extends Vue {}
